import script from "./ProductServices.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductServices.vue?vue&type=script&lang=ts&setup=true"

import "./ProductServices.vue?vue&type=style&index=0&id=18048be4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18048be4"]])

export default __exports__